import React from "react";
import { motion } from "framer-motion";
import "./Skills.css";

const Skill = ({ name, x, y }) => {
  return (
    <motion.div
      className="skills"
      initial={{ x: 0, y: 0 }}
      whileInView={{ x: x, y: y }}
      transition={{ duration: 1.5 }}
     viewport={{once:true}}
    >
      <span className="skill">{name}</span>
    </motion.div>
  );
};

const Skills = () => {
  return (
    <div className="skills-section">
      <h1 className="skills-text">Skills</h1>

        <div className="desktop-skills">
        <motion.div className="skills">
          <Skill name="HTML5" x="0vw" y="-11vw" />
          <Skill name="CSS3" x="18vw" y="12vw" />
          <Skill name="JavaScript ES6+" x="-23vw" y="0vw" />
          <Skill name="React.js" x="0vw" y="14vw" />
          <Skill name="SaSS" x="18vw" y="-12vw" />
          <Skill name="Design Principles" x="23vw" y="-3vw" />
          <Skill name="REST API" x="-16vw" y="-15vw" />
          <Skill name="GIT" x="-17vw" y="5vw" />
          <Skill name="Web" x="0vw" y="-8.6vw" />
          <Skill name="Framer Motion" x="-5vw" y="-16vw" />
          <Skill name="Tailwind" x="5vw" y="-2vw" />
          <Skill name="TypeScript" x="15vw" y="-6vw" />
          <Skill name="Next.js" x="11vw" y="-19vw" />
          <Skill name="Redux" x="-10vw" y="-8vw" />
          <Skill name="UI/UX" x="-25vw" y="-10vw" />
        </motion.div>
      </div>

      <div className="web-skills">
        <motion.div className="skills">
          <Skill name="HTML" x="-7vw" y="-5vw" />
          <Skill name="CSS" x="1vw" y="40vw" />
          <Skill name="JavaScript" x="-44vw" y="-10vw" />
          <Skill name="ReactJS" x="-20vw" y="34vw" />
          <Skill name="SaSS" x="18vw" y="-12vw" />
          <Skill name="ResponsiveDesign" x="8vw" y="4vw" />
          <Skill name="API" x="-16vw" y="-15vw" />
          <Skill name="GIT" x="-37vw" y="20vw" />
          <Skill name="Web" x="-9vw" y="-3vw" />
          <Skill name="FramerMotion" x="-52vw" y="-10vw" />
          <Skill name="Tailwind" x="14vw" y="12vw" />
        </motion.div>
      </div>
    </div>
  );
};

export default Skills;
